export enum ProjectStatus {
    Indeterminate = 0,
    AssessmentRequested = 1,
    CustomerUnresponsive = 2,
    AssessmentScheduled = 3,
    AssessmentCancelled = 4,
    ProjectRejected = 5,
    CatalogPublished = 6,
    ProjectInPlanning = 7,
    ProjectPlanned = 8,
    CustomerDisinterested = 9,
    InstallationPurchased = 10,
    InstallationScheduled = 11,
    InstallationInProgress = 12,
    InstallationCancelled = 13,
    InstallationRejected = 14,
    InstallationCompleted = 15,
    CustomerBanned = 16,
}

